import React from 'react';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import { routerMiddleware, ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { all } from 'redux-saga/effects';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import { ThemeProvider } from 'styled-components';
import { Switch, Route } from 'react-router';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import Main from './containers/Main';
import LanguageProvider from './components/LanguageProvider';
import theme from './utils/theme';
import registerPageSagas from './containers/RegisterPage/sagas';
import loginPageSagas from './containers/LoginPage/sagas';
import notesPageSagas from './containers/NotesPage/sagas';
import noteEditPageSagas from './containers/NoteEditPage/sagas';
import ReactGA from 'react-ga';
import config from './config';
import 'react-toastify/dist/ReactToastify.css';
import forgotPasswordSagas from './containers/ForgotPage/sagas';
import otpVerifySagas from './containers/OtpVerifyPage/sagas';
import resetPasswordSagas from './containers/ResetPasswordPage/sagas';
import settingsSagas from './containers/Settings/sagas';
import TemplateSagas from './containers/Template/sagas';
import createRootReducer from './rootReducer'; // <-- import it

ReactGA.initialize(config.gaId);
const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const rootReducer = createRootReducer(history);
const persistedReducer = persistReducer(
  {
    key: 'root',
    storage,
    blacklist: ['template', 'forgotPassword', 'otpVerify', 'resetPassword'],
    transforms: [
      createBlacklistFilter('main', 'speech'),
      createBlacklistFilter('main', 'loadings'),
      createBlacklistFilter('form', 'login'),
      createBlacklistFilter('form', 'register'),
      createBlacklistFilter('form', 'forgot'),
      createBlacklistFilter('form', 'settings'),
      createBlacklistFilter('form', 'otpVerify'),
      createBlacklistFilter('form', 'resetPassword'),
      createBlacklistFilter('template', 'template'),
    ],
  },
  rootReducer
);

const store = createStore(
  persistedReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware, routerMiddleware(history))
  )
);
let persistor = persistStore(store);

function* rootSaga() {
  yield all([
    ...registerPageSagas,
    ...loginPageSagas,
    ...notesPageSagas,
    ...settingsSagas,
    ...noteEditPageSagas,
    ...TemplateSagas,
    ...forgotPasswordSagas,
    ...otpVerifySagas,
    ...resetPasswordSagas,
  ]);
}
sagaMiddleware.run(rootSaga);

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LanguageProvider>
        <ConnectedRouter history={history}>
          <ThemeProvider theme={theme}>
            <Switch>
              <Route path="/" component={Main} />
            </Switch>
          </ThemeProvider>
        </ConnectedRouter>
      </LanguageProvider>
    </PersistGate>
  </Provider>
);

export default App;
